var ae = (o) => {
  throw TypeError(o);
};
var ce = (o, t, e) => t.has(o) || ae("Cannot " + e);
var le = (o, t, e) => (ce(o, t, "read from private field"), e ? e.call(o) : t.get(o)), he = (o, t, e) => t.has(o) ? ae("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(o) : t.set(o, e), X = (o, t, e, r) => (ce(o, t, "write to private field"), r ? r.call(o, e) : t.set(o, e), e);
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const K = globalThis, re = K.ShadowRoot && (K.ShadyCSS === void 0 || K.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, ie = Symbol(), de = /* @__PURE__ */ new WeakMap();
let Pe = class {
  constructor(t, e, r) {
    if (this._$cssResult$ = !0, r !== ie) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
    this.cssText = t, this.t = e;
  }
  get styleSheet() {
    let t = this.o;
    const e = this.t;
    if (re && t === void 0) {
      const r = e !== void 0 && e.length === 1;
      r && (t = de.get(e)), t === void 0 && ((this.o = t = new CSSStyleSheet()).replaceSync(this.cssText), r && de.set(e, t));
    }
    return t;
  }
  toString() {
    return this.cssText;
  }
};
const ze = (o) => new Pe(typeof o == "string" ? o : o + "", void 0, ie), V = (o, ...t) => {
  const e = o.length === 1 ? o[0] : t.reduce((r, i, s) => r + ((n) => {
    if (n._$cssResult$ === !0) return n.cssText;
    if (typeof n == "number") return n;
    throw Error("Value passed to 'css' function must be a 'css' function result: " + n + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
  })(i) + o[s + 1], o[0]);
  return new Pe(e, o, ie);
}, Fe = (o, t) => {
  if (re) o.adoptedStyleSheets = t.map((e) => e instanceof CSSStyleSheet ? e : e.styleSheet);
  else for (const e of t) {
    const r = document.createElement("style"), i = K.litNonce;
    i !== void 0 && r.setAttribute("nonce", i), r.textContent = e.cssText, o.appendChild(r);
  }
}, ue = re ? (o) => o : (o) => o instanceof CSSStyleSheet ? ((t) => {
  let e = "";
  for (const r of t.cssRules) e += r.cssText;
  return ze(e);
})(o) : o;
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const { is: Ke, defineProperty: We, getOwnPropertyDescriptor: Ge, getOwnPropertyNames: Ye, getOwnPropertySymbols: qe, getPrototypeOf: Xe } = Object, A = globalThis, pe = A.trustedTypes, Ze = pe ? pe.emptyScript : "", Z = A.reactiveElementPolyfillSupport, k = (o, t) => o, Y = { toAttribute(o, t) {
  switch (t) {
    case Boolean:
      o = o ? Ze : null;
      break;
    case Object:
    case Array:
      o = o == null ? o : JSON.stringify(o);
  }
  return o;
}, fromAttribute(o, t) {
  let e = o;
  switch (t) {
    case Boolean:
      e = o !== null;
      break;
    case Number:
      e = o === null ? null : Number(o);
      break;
    case Object:
    case Array:
      try {
        e = JSON.parse(o);
      } catch {
        e = null;
      }
  }
  return e;
} }, oe = (o, t) => !Ke(o, t), be = { attribute: !0, type: String, converter: Y, reflect: !1, hasChanged: oe };
var Se, Ee;
(Se = Symbol.metadata) != null || (Symbol.metadata = Symbol("metadata")), (Ee = A.litPropertyMetadata) != null || (A.litPropertyMetadata = /* @__PURE__ */ new WeakMap());
class T extends HTMLElement {
  static addInitializer(t) {
    var e;
    this._$Ei(), ((e = this.l) != null ? e : this.l = []).push(t);
  }
  static get observedAttributes() {
    return this.finalize(), this._$Eh && [...this._$Eh.keys()];
  }
  static createProperty(t, e = be) {
    if (e.state && (e.attribute = !1), this._$Ei(), this.elementProperties.set(t, e), !e.noAccessor) {
      const r = Symbol(), i = this.getPropertyDescriptor(t, r, e);
      i !== void 0 && We(this.prototype, t, i);
    }
  }
  static getPropertyDescriptor(t, e, r) {
    var n;
    const { get: i, set: s } = (n = Ge(this.prototype, t)) != null ? n : { get() {
      return this[e];
    }, set(c) {
      this[e] = c;
    } };
    return { get() {
      return i == null ? void 0 : i.call(this);
    }, set(c) {
      const a = i == null ? void 0 : i.call(this);
      s.call(this, c), this.requestUpdate(t, a, r);
    }, configurable: !0, enumerable: !0 };
  }
  static getPropertyOptions(t) {
    var e;
    return (e = this.elementProperties.get(t)) != null ? e : be;
  }
  static _$Ei() {
    if (this.hasOwnProperty(k("elementProperties"))) return;
    const t = Xe(this);
    t.finalize(), t.l !== void 0 && (this.l = [...t.l]), this.elementProperties = new Map(t.elementProperties);
  }
  static finalize() {
    if (this.hasOwnProperty(k("finalized"))) return;
    if (this.finalized = !0, this._$Ei(), this.hasOwnProperty(k("properties"))) {
      const e = this.properties, r = [...Ye(e), ...qe(e)];
      for (const i of r) this.createProperty(i, e[i]);
    }
    const t = this[Symbol.metadata];
    if (t !== null) {
      const e = litPropertyMetadata.get(t);
      if (e !== void 0) for (const [r, i] of e) this.elementProperties.set(r, i);
    }
    this._$Eh = /* @__PURE__ */ new Map();
    for (const [e, r] of this.elementProperties) {
      const i = this._$Eu(e, r);
      i !== void 0 && this._$Eh.set(i, e);
    }
    this.elementStyles = this.finalizeStyles(this.styles);
  }
  static finalizeStyles(t) {
    const e = [];
    if (Array.isArray(t)) {
      const r = new Set(t.flat(1 / 0).reverse());
      for (const i of r) e.unshift(ue(i));
    } else t !== void 0 && e.push(ue(t));
    return e;
  }
  static _$Eu(t, e) {
    const r = e.attribute;
    return r === !1 ? void 0 : typeof r == "string" ? r : typeof t == "string" ? t.toLowerCase() : void 0;
  }
  constructor() {
    super(), this._$Ep = void 0, this.isUpdatePending = !1, this.hasUpdated = !1, this._$Em = null, this._$Ev();
  }
  _$Ev() {
    var t;
    this._$ES = new Promise((e) => this.enableUpdating = e), this._$AL = /* @__PURE__ */ new Map(), this._$E_(), this.requestUpdate(), (t = this.constructor.l) == null || t.forEach((e) => e(this));
  }
  addController(t) {
    var e, r;
    ((e = this._$EO) != null ? e : this._$EO = /* @__PURE__ */ new Set()).add(t), this.renderRoot !== void 0 && this.isConnected && ((r = t.hostConnected) == null || r.call(t));
  }
  removeController(t) {
    var e;
    (e = this._$EO) == null || e.delete(t);
  }
  _$E_() {
    const t = /* @__PURE__ */ new Map(), e = this.constructor.elementProperties;
    for (const r of e.keys()) this.hasOwnProperty(r) && (t.set(r, this[r]), delete this[r]);
    t.size > 0 && (this._$Ep = t);
  }
  createRenderRoot() {
    var e;
    const t = (e = this.shadowRoot) != null ? e : this.attachShadow(this.constructor.shadowRootOptions);
    return Fe(t, this.constructor.elementStyles), t;
  }
  connectedCallback() {
    var t, e;
    (t = this.renderRoot) != null || (this.renderRoot = this.createRenderRoot()), this.enableUpdating(!0), (e = this._$EO) == null || e.forEach((r) => {
      var i;
      return (i = r.hostConnected) == null ? void 0 : i.call(r);
    });
  }
  enableUpdating(t) {
  }
  disconnectedCallback() {
    var t;
    (t = this._$EO) == null || t.forEach((e) => {
      var r;
      return (r = e.hostDisconnected) == null ? void 0 : r.call(e);
    });
  }
  attributeChangedCallback(t, e, r) {
    this._$AK(t, r);
  }
  _$EC(t, e) {
    var s;
    const r = this.constructor.elementProperties.get(t), i = this.constructor._$Eu(t, r);
    if (i !== void 0 && r.reflect === !0) {
      const n = (((s = r.converter) == null ? void 0 : s.toAttribute) !== void 0 ? r.converter : Y).toAttribute(e, r.type);
      this._$Em = t, n == null ? this.removeAttribute(i) : this.setAttribute(i, n), this._$Em = null;
    }
  }
  _$AK(t, e) {
    var s;
    const r = this.constructor, i = r._$Eh.get(t);
    if (i !== void 0 && this._$Em !== i) {
      const n = r.getPropertyOptions(i), c = typeof n.converter == "function" ? { fromAttribute: n.converter } : ((s = n.converter) == null ? void 0 : s.fromAttribute) !== void 0 ? n.converter : Y;
      this._$Em = i, this[i] = c.fromAttribute(e, n.type), this._$Em = null;
    }
  }
  requestUpdate(t, e, r) {
    var i;
    if (t !== void 0) {
      if (r != null || (r = this.constructor.getPropertyOptions(t)), !((i = r.hasChanged) != null ? i : oe)(this[t], e)) return;
      this.P(t, e, r);
    }
    this.isUpdatePending === !1 && (this._$ES = this._$ET());
  }
  P(t, e, r) {
    var i;
    this._$AL.has(t) || this._$AL.set(t, e), r.reflect === !0 && this._$Em !== t && ((i = this._$Ej) != null ? i : this._$Ej = /* @__PURE__ */ new Set()).add(t);
  }
  async _$ET() {
    this.isUpdatePending = !0;
    try {
      await this._$ES;
    } catch (e) {
      Promise.reject(e);
    }
    const t = this.scheduleUpdate();
    return t != null && await t, !this.isUpdatePending;
  }
  scheduleUpdate() {
    return this.performUpdate();
  }
  performUpdate() {
    var r, i;
    if (!this.isUpdatePending) return;
    if (!this.hasUpdated) {
      if ((r = this.renderRoot) != null || (this.renderRoot = this.createRenderRoot()), this._$Ep) {
        for (const [n, c] of this._$Ep) this[n] = c;
        this._$Ep = void 0;
      }
      const s = this.constructor.elementProperties;
      if (s.size > 0) for (const [n, c] of s) c.wrapped !== !0 || this._$AL.has(n) || this[n] === void 0 || this.P(n, this[n], c);
    }
    let t = !1;
    const e = this._$AL;
    try {
      t = this.shouldUpdate(e), t ? (this.willUpdate(e), (i = this._$EO) == null || i.forEach((s) => {
        var n;
        return (n = s.hostUpdate) == null ? void 0 : n.call(s);
      }), this.update(e)) : this._$EU();
    } catch (s) {
      throw t = !1, this._$EU(), s;
    }
    t && this._$AE(e);
  }
  willUpdate(t) {
  }
  _$AE(t) {
    var e;
    (e = this._$EO) == null || e.forEach((r) => {
      var i;
      return (i = r.hostUpdated) == null ? void 0 : i.call(r);
    }), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
  }
  _$EU() {
    this._$AL = /* @__PURE__ */ new Map(), this.isUpdatePending = !1;
  }
  get updateComplete() {
    return this.getUpdateComplete();
  }
  getUpdateComplete() {
    return this._$ES;
  }
  shouldUpdate(t) {
    return !0;
  }
  update(t) {
    this._$Ej && (this._$Ej = this._$Ej.forEach((e) => this._$EC(e, this[e]))), this._$EU();
  }
  updated(t) {
  }
  firstUpdated(t) {
  }
}
var Ce;
T.elementStyles = [], T.shadowRootOptions = { mode: "open" }, T[k("elementProperties")] = /* @__PURE__ */ new Map(), T[k("finalized")] = /* @__PURE__ */ new Map(), Z == null || Z({ ReactiveElement: T }), ((Ce = A.reactiveElementVersions) != null ? Ce : A.reactiveElementVersions = []).push("2.0.4");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const M = globalThis, q = M.trustedTypes, fe = q ? q.createPolicy("lit-html", { createHTML: (o) => o }) : void 0, se = "$lit$", _ = `lit$${Math.random().toFixed(9).slice(2)}$`, ne = "?" + _, Je = `<${ne}>`, C = document, I = () => C.createComment(""), H = (o) => o === null || typeof o != "object" && typeof o != "function", Oe = Array.isArray, xe = (o) => Oe(o) || typeof (o == null ? void 0 : o[Symbol.iterator]) == "function", J = `[ 	
\f\r]`, R = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, me = /-->/g, ge = />/g, S = RegExp(`>|${J}(?:([^\\s"'>=/]+)(${J}*=${J}*(?:[^ 	
\f\r"'\`<>=]|("|')|))|$)`, "g"), ve = /'/g, ye = /"/g, Le = /^(?:script|style|textarea|title)$/i, Qe = (o) => (t, ...e) => ({ _$litType$: o, strings: t, values: e }), Be = Qe(1), x = Symbol.for("lit-noChange"), u = Symbol.for("lit-nothing"), $e = /* @__PURE__ */ new WeakMap(), E = C.createTreeWalker(C, 129);
function Re(o, t) {
  if (!Array.isArray(o) || !o.hasOwnProperty("raw")) throw Error("invalid template strings array");
  return fe !== void 0 ? fe.createHTML(t) : t;
}
const Ue = (o, t) => {
  const e = o.length - 1, r = [];
  let i, s = t === 2 ? "<svg>" : "", n = R;
  for (let c = 0; c < e; c++) {
    const a = o[c];
    let l, h, d = -1, b = 0;
    for (; b < a.length && (n.lastIndex = b, h = n.exec(a), h !== null); ) b = n.lastIndex, n === R ? h[1] === "!--" ? n = me : h[1] !== void 0 ? n = ge : h[2] !== void 0 ? (Le.test(h[2]) && (i = RegExp("</" + h[2], "g")), n = S) : h[3] !== void 0 && (n = S) : n === S ? h[0] === ">" ? (n = i != null ? i : R, d = -1) : h[1] === void 0 ? d = -2 : (d = n.lastIndex - h[2].length, l = h[1], n = h[3] === void 0 ? S : h[3] === '"' ? ye : ve) : n === ye || n === ve ? n = S : n === me || n === ge ? n = R : (n = S, i = void 0);
    const p = n === S && o[c + 1].startsWith("/>") ? " " : "";
    s += n === R ? a + Je : d >= 0 ? (r.push(l), a.slice(0, d) + se + a.slice(d) + _ + p) : a + _ + (d === -2 ? c : p);
  }
  return [Re(o, s + (o[e] || "<?>") + (t === 2 ? "</svg>" : "")), r];
};
class j {
  constructor({ strings: t, _$litType$: e }, r) {
    let i;
    this.parts = [];
    let s = 0, n = 0;
    const c = t.length - 1, a = this.parts, [l, h] = Ue(t, e);
    if (this.el = j.createElement(l, r), E.currentNode = this.el.content, e === 2) {
      const d = this.el.content.firstChild;
      d.replaceWith(...d.childNodes);
    }
    for (; (i = E.nextNode()) !== null && a.length < c; ) {
      if (i.nodeType === 1) {
        if (i.hasAttributes()) for (const d of i.getAttributeNames()) if (d.endsWith(se)) {
          const b = h[n++], p = i.getAttribute(d).split(_), F = /([.?@])?(.*)/.exec(b);
          a.push({ type: 1, index: s, name: F[2], strings: p, ctor: F[1] === "." ? Me : F[1] === "?" ? Ie : F[1] === "@" ? He : z }), i.removeAttribute(d);
        } else d.startsWith(_) && (a.push({ type: 6, index: s }), i.removeAttribute(d));
        if (Le.test(i.tagName)) {
          const d = i.textContent.split(_), b = d.length - 1;
          if (b > 0) {
            i.textContent = q ? q.emptyScript : "";
            for (let p = 0; p < b; p++) i.append(d[p], I()), E.nextNode(), a.push({ type: 2, index: ++s });
            i.append(d[b], I());
          }
        }
      } else if (i.nodeType === 8) if (i.data === ne) a.push({ type: 2, index: s });
      else {
        let d = -1;
        for (; (d = i.data.indexOf(_, d + 1)) !== -1; ) a.push({ type: 7, index: s }), d += _.length - 1;
      }
      s++;
    }
  }
  static createElement(t, e) {
    const r = C.createElement("template");
    return r.innerHTML = t, r;
  }
}
function D(o, t, e = o, r) {
  var n, c, a;
  if (t === x) return t;
  let i = r !== void 0 ? (n = e._$Co) == null ? void 0 : n[r] : e._$Cl;
  const s = H(t) ? void 0 : t._$litDirective$;
  return (i == null ? void 0 : i.constructor) !== s && ((c = i == null ? void 0 : i._$AO) == null || c.call(i, !1), s === void 0 ? i = void 0 : (i = new s(o), i._$AT(o, e, r)), r !== void 0 ? ((a = e._$Co) != null ? a : e._$Co = [])[r] = i : e._$Cl = i), i !== void 0 && (t = D(o, i._$AS(o, t.values), i, r)), t;
}
class ke {
  constructor(t, e) {
    this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = e;
  }
  get parentNode() {
    return this._$AM.parentNode;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  u(t) {
    var l;
    const { el: { content: e }, parts: r } = this._$AD, i = ((l = t == null ? void 0 : t.creationScope) != null ? l : C).importNode(e, !0);
    E.currentNode = i;
    let s = E.nextNode(), n = 0, c = 0, a = r[0];
    for (; a !== void 0; ) {
      if (n === a.index) {
        let h;
        a.type === 2 ? h = new L(s, s.nextSibling, this, t) : a.type === 1 ? h = new a.ctor(s, a.name, a.strings, this, t) : a.type === 6 && (h = new je(s, this, t)), this._$AV.push(h), a = r[++c];
      }
      n !== (a == null ? void 0 : a.index) && (s = E.nextNode(), n++);
    }
    return E.currentNode = C, i;
  }
  p(t) {
    let e = 0;
    for (const r of this._$AV) r !== void 0 && (r.strings !== void 0 ? (r._$AI(t, r, e), e += r.strings.length - 2) : r._$AI(t[e])), e++;
  }
}
class L {
  get _$AU() {
    var t, e;
    return (e = (t = this._$AM) == null ? void 0 : t._$AU) != null ? e : this._$Cv;
  }
  constructor(t, e, r, i) {
    var s;
    this.type = 2, this._$AH = u, this._$AN = void 0, this._$AA = t, this._$AB = e, this._$AM = r, this.options = i, this._$Cv = (s = i == null ? void 0 : i.isConnected) != null ? s : !0;
  }
  get parentNode() {
    let t = this._$AA.parentNode;
    const e = this._$AM;
    return e !== void 0 && (t == null ? void 0 : t.nodeType) === 11 && (t = e.parentNode), t;
  }
  get startNode() {
    return this._$AA;
  }
  get endNode() {
    return this._$AB;
  }
  _$AI(t, e = this) {
    t = D(this, t, e), H(t) ? t === u || t == null || t === "" ? (this._$AH !== u && this._$AR(), this._$AH = u) : t !== this._$AH && t !== x && this._(t) : t._$litType$ !== void 0 ? this.$(t) : t.nodeType !== void 0 ? this.T(t) : xe(t) ? this.k(t) : this._(t);
  }
  S(t) {
    return this._$AA.parentNode.insertBefore(t, this._$AB);
  }
  T(t) {
    this._$AH !== t && (this._$AR(), this._$AH = this.S(t));
  }
  _(t) {
    this._$AH !== u && H(this._$AH) ? this._$AA.nextSibling.data = t : this.T(C.createTextNode(t)), this._$AH = t;
  }
  $(t) {
    var s;
    const { values: e, _$litType$: r } = t, i = typeof r == "number" ? this._$AC(t) : (r.el === void 0 && (r.el = j.createElement(Re(r.h, r.h[0]), this.options)), r);
    if (((s = this._$AH) == null ? void 0 : s._$AD) === i) this._$AH.p(e);
    else {
      const n = new ke(i, this), c = n.u(this.options);
      n.p(e), this.T(c), this._$AH = n;
    }
  }
  _$AC(t) {
    let e = $e.get(t.strings);
    return e === void 0 && $e.set(t.strings, e = new j(t)), e;
  }
  k(t) {
    Oe(this._$AH) || (this._$AH = [], this._$AR());
    const e = this._$AH;
    let r, i = 0;
    for (const s of t) i === e.length ? e.push(r = new L(this.S(I()), this.S(I()), this, this.options)) : r = e[i], r._$AI(s), i++;
    i < e.length && (this._$AR(r && r._$AB.nextSibling, i), e.length = i);
  }
  _$AR(t = this._$AA.nextSibling, e) {
    var r;
    for ((r = this._$AP) == null ? void 0 : r.call(this, !1, !0, e); t && t !== this._$AB; ) {
      const i = t.nextSibling;
      t.remove(), t = i;
    }
  }
  setConnected(t) {
    var e;
    this._$AM === void 0 && (this._$Cv = t, (e = this._$AP) == null || e.call(this, t));
  }
}
class z {
  get tagName() {
    return this.element.tagName;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  constructor(t, e, r, i, s) {
    this.type = 1, this._$AH = u, this._$AN = void 0, this.element = t, this.name = e, this._$AM = i, this.options = s, r.length > 2 || r[0] !== "" || r[1] !== "" ? (this._$AH = Array(r.length - 1).fill(new String()), this.strings = r) : this._$AH = u;
  }
  _$AI(t, e = this, r, i) {
    const s = this.strings;
    let n = !1;
    if (s === void 0) t = D(this, t, e, 0), n = !H(t) || t !== this._$AH && t !== x, n && (this._$AH = t);
    else {
      const c = t;
      let a, l;
      for (t = s[0], a = 0; a < s.length - 1; a++) l = D(this, c[r + a], e, a), l === x && (l = this._$AH[a]), n || (n = !H(l) || l !== this._$AH[a]), l === u ? t = u : t !== u && (t += (l != null ? l : "") + s[a + 1]), this._$AH[a] = l;
    }
    n && !i && this.j(t);
  }
  j(t) {
    t === u ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, t != null ? t : "");
  }
}
class Me extends z {
  constructor() {
    super(...arguments), this.type = 3;
  }
  j(t) {
    this.element[this.name] = t === u ? void 0 : t;
  }
}
class Ie extends z {
  constructor() {
    super(...arguments), this.type = 4;
  }
  j(t) {
    this.element.toggleAttribute(this.name, !!t && t !== u);
  }
}
class He extends z {
  constructor(t, e, r, i, s) {
    super(t, e, r, i, s), this.type = 5;
  }
  _$AI(t, e = this) {
    var n;
    if ((t = (n = D(this, t, e, 0)) != null ? n : u) === x) return;
    const r = this._$AH, i = t === u && r !== u || t.capture !== r.capture || t.once !== r.once || t.passive !== r.passive, s = t !== u && (r === u || i);
    i && this.element.removeEventListener(this.name, this, r), s && this.element.addEventListener(this.name, this, t), this._$AH = t;
  }
  handleEvent(t) {
    var e, r;
    typeof this._$AH == "function" ? this._$AH.call((r = (e = this.options) == null ? void 0 : e.host) != null ? r : this.element, t) : this._$AH.handleEvent(t);
  }
}
class je {
  constructor(t, e, r) {
    this.element = t, this.type = 6, this._$AN = void 0, this._$AM = e, this.options = r;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  _$AI(t) {
    D(this, t);
  }
}
const $t = { P: se, A: _, C: ne, M: 1, L: Ue, R: ke, D: xe, V: D, I: L, H: z, N: Ie, U: He, B: Me, F: je }, Q = M.litHtmlPolyfillSupport;
var De;
Q == null || Q(j, L), ((De = M.litHtmlVersions) != null ? De : M.litHtmlVersions = []).push("3.1.3");
const et = (o, t, e) => {
  var s, n;
  const r = (s = e == null ? void 0 : e.renderBefore) != null ? s : t;
  let i = r._$litPart$;
  if (i === void 0) {
    const c = (n = e == null ? void 0 : e.renderBefore) != null ? n : null;
    r._$litPart$ = i = new L(t.insertBefore(I(), c), c, void 0, e != null ? e : {});
  }
  return i._$AI(o), i;
};
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
class N extends T {
  constructor() {
    super(...arguments), this.renderOptions = { host: this }, this._$Do = void 0;
  }
  createRenderRoot() {
    var e, r;
    const t = super.createRenderRoot();
    return (r = (e = this.renderOptions).renderBefore) != null || (e.renderBefore = t.firstChild), t;
  }
  update(t) {
    const e = this.render();
    this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this._$Do = et(e, this.renderRoot, this.renderOptions);
  }
  connectedCallback() {
    var t;
    super.connectedCallback(), (t = this._$Do) == null || t.setConnected(!0);
  }
  disconnectedCallback() {
    var t;
    super.disconnectedCallback(), (t = this._$Do) == null || t.setConnected(!1);
  }
  render() {
    return x;
  }
}
var Te;
N._$litElement$ = !0, N.finalized = !0, (Te = globalThis.litElementHydrateSupport) == null || Te.call(globalThis, { LitElement: N });
const B = globalThis.litElementPolyfillSupport;
B == null || B({ LitElement: N });
var Ne;
((Ne = globalThis.litElementVersions) != null ? Ne : globalThis.litElementVersions = []).push("4.0.5");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const tt = { attribute: !0, type: String, converter: Y, reflect: !1, hasChanged: oe }, rt = (o = tt, t, e) => {
  const { kind: r, metadata: i } = e;
  let s = globalThis.litPropertyMetadata.get(i);
  if (s === void 0 && globalThis.litPropertyMetadata.set(i, s = /* @__PURE__ */ new Map()), s.set(e.name, o), r === "accessor") {
    const { name: n } = e;
    return { set(c) {
      const a = t.get.call(this);
      t.set.call(this, c), this.requestUpdate(n, a, o);
    }, init(c) {
      return c !== void 0 && this.P(n, void 0, o), c;
    } };
  }
  if (r === "setter") {
    const { name: n } = e;
    return function(c) {
      const a = this[n];
      t.call(this, c), this.requestUpdate(n, a, o);
    };
  }
  throw Error("Unsupported decorator location: " + r);
};
function m(o) {
  return (t, e) => typeof e == "object" ? rt(o, t, e) : ((r, i, s) => {
    const n = i.hasOwnProperty(s);
    return i.constructor.createProperty(s, n ? { ...r, wrapped: !0 } : r), n ? Object.getOwnPropertyDescriptor(i, s) : void 0;
  })(o, t, e);
}
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function it(o) {
  return m({ ...o, state: !0, attribute: !1 });
}
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const Ve = Symbol.for(""), ot = (o) => {
  if ((o == null ? void 0 : o.r) === Ve) return o == null ? void 0 : o._$litStatic$;
}, st = (o) => ({ _$litStatic$: o, r: Ve }), _e = /* @__PURE__ */ new Map(), nt = (o) => (t, ...e) => {
  const r = e.length;
  let i, s;
  const n = [], c = [];
  let a, l = 0, h = !1;
  for (; l < r; ) {
    for (a = t[l]; l < r && (s = e[l], (i = ot(s)) !== void 0); ) a += i + t[++l], h = !0;
    l !== r && c.push(s), n.push(a), l++;
  }
  if (l === r && n.push(t[r]), h) {
    const d = n.join("$$lit$$");
    (t = _e.get(d)) === void 0 && (n.raw = n, _e.set(d, t = n)), e = c;
  }
  return o(t, ...e);
}, _t = nt(Be);
var W = /* @__PURE__ */ ((o) => (o.NO_SYNC = "no-sync", o))(W || {}), P = /* @__PURE__ */ ((o) => (o.VISIBLE = "visible", o.IDLE = "idle", o.INTERACTION = "interaction", o.MEDIA = "media", o.DEFINED = "defined", o))(P || {}), $ = /* @__PURE__ */ ((o) => (o.BLUR = "beacon-event-blur", o.CHANGE = "beacon-event-change", o.CLICK = "beacon-event-click", o.FOCUS = "beacon-event-focus", o.HIDE = "beacon-event-hide", o.INPUT = "beacon-event-input", o.KEYDOWN = "beacon-event-keydown", o.MOUSEDOWN = "beacon-event-mousedown", o.MOUSEENTER = "beacon-event-mouseenter", o.MOUSELEAVE = "beacon-event-mouseleave", o.RENDER = "beacon-event-render", o.SORT = "beacon-event-sort", o.DEFERRED_CHILD = "beacon-event-deferred-child", o.RENDER_ACTION_ZONE = "beacon-event-render-action-zone", o.RENDER_TABLE_CARDS = "beacon-event-render-table-cards", o.LANGUAGE_SELECT = "beacon-event-language-select", o.PLAY = "beacon-event-play", o.CLOSE = "beacon-event-close", o.OPEN = "beacon-event-open", o.NAV_LANGUAGE_SELECT = "beacon-event-language-selected", o.CLOSE_ACTIVE_NAV_ITEM = "beacon-event-close-active-nav-item", o.ELEMENT_READY = "beacon-event-element-ready", o.ACTIVE_NAV_ITEM = "beacon-event-active-nav-item-change", o.DRILLDOWN = "beacon-event-drilldown", o.DRILLUP = "beacon-event-drillup", o.HEADER_ZONE_CLICK = "beacon-event-navigation-header-zone-click", o.COUNTRY_SELECTOR_CLOSE = "beacon-event-country-selector-close", o.COUNTRY_SELECTOR_OPEN = "beacon-event-country-selector-open", o.COUNTRY_FLAG_CHANGE = "beacon-event-country-flag-change", o.HAS_CURRENT_LINK = "beacon-event-has-current-link", o.REGISTER = "beacon-event-register", o.SKIP_LINK_CLICK = "beacon-event-skip-link-click", o.METRICS_SECTION_CHANGE = "beacon-event-metrics-section-change", o.METRICS_LOCATION_CHANGE = "beacon-event-metrics-location-change", o.METRICS_ID_CHANGE = "beacon-event-metrics-id-change", o.NAVIGATION_LINK_CLICK = "beacon-event-navigation-link-click", o.DISMISS = "beacon-event-dismiss", o.TOGGLE = "beacon-event-toggle", o.CONTROL_SET = "beacon-event-control-set", o))($ || {}), at = /* @__PURE__ */ ((o) => (o.CLOSE = "close", o.KEYDOWN = "keydown", o.SCROLL = "scroll", o.CLICK = "click", o.FOCUSOUT = "focusout", o))(at || {});
const ct = V`[beacon-tag-name]:not([focus-override]) *:focus-visible:not(a:not([focus-override])){--heritage-width-border-normal: calc(var(--beacon-unit-base) / 8);--heritage-width-border-jumbo: calc(var(--beacon-unit-base) / 4);--heritage-width-border-maxi: calc(var(--beacon-unit-base) / 2);--total-ring-width: calc(var(--beacon-system-width-border-jumbo, var(--heritage-width-border-jumbo)) + var(--beacon-system-width-border-maxi, var(--heritage-width-border-maxi)) + var(--beacon-system-width-border-normal, var(--heritage-width-border-normal)));box-shadow:0 0 0 var(--beacon-system-width-border-jumbo, var(--heritage-width-border-jumbo)) var(--beacon-system-color-border-focus-middle, var(--beacon-color-outline-focus)),0 0 0 var(--beacon-system-width-border-maxi, var(--heritage-width-border-maxi)) var(--beacon-system-color-border-focus-outer, var(--beacon-color-shadow-focus));outline:var(--beacon-system-width-border-normal, var(--heritage-width-border-normal)) solid var(--beacon-system-color-border-focus-inner, var(--beacon-color-border-focus));outline-offset:0;position:relative;z-index:1}[beacon-tag-name]:not([focus-override]) a:not([focus-override]):focus-visible{--heritage-width-border-normal: calc(var(--beacon-unit-base) / 8);--heritage-width-border-jumbo: calc(var(--beacon-unit-base) / 4);--heritage-width-border-maxi: calc(var(--beacon-unit-base) / 2);--total-ring-width: calc(var(--beacon-system-width-border-jumbo, var(--heritage-width-border-jumbo)) + var(--beacon-system-width-border-maxi, var(--heritage-width-border-maxi)) + var(--beacon-system-width-border-normal, var(--heritage-width-border-normal)));background-color:var(--beacon-system-color-background-link-focus, var(--beacon-color-background-link-focus))!important;border-block-end-color:unset;box-shadow:0 var(--beacon-system-width-border-jumbo, var(--heritage-width-border-jumbo)) 0 0 var(--beacon-system-color-border-link-focus, var(--beacon-color-border-link-focus));color:var(--beacon-system-color-text-set-navy, var(--beacon-color-text-set-navy))!important;outline:none;text-decoration:none}@media (forced-colors: active){[beacon-tag-name]:not([focus-override]) a:not([focus-override]):focus-visible{border-block-end:var(--beacon-system-width-border-jumbo, var(--heritage-width-border-jumbo)) solid var(--beacon-system-color-border-link-focus, var(--beacon-color-border-link-focus))}}`, lt = V`:host(:not([focus-override])) *:not(a:not([focus-override])):focus-visible{--heritage-width-border-normal: calc(var(--beacon-unit-base) / 8);--heritage-width-border-jumbo: calc(var(--beacon-unit-base) / 4);--heritage-width-border-maxi: calc(var(--beacon-unit-base) / 2);--total-ring-width: calc(var(--beacon-system-width-border-jumbo, var(--heritage-width-border-jumbo)) + var(--beacon-system-width-border-maxi, var(--heritage-width-border-maxi)) + var(--beacon-system-width-border-normal, var(--heritage-width-border-normal)));box-shadow:0 0 0 var(--beacon-system-width-border-jumbo, var(--heritage-width-border-jumbo)) var(--beacon-system-color-border-focus-middle, var(--beacon-color-outline-focus)),0 0 0 var(--beacon-system-width-border-maxi, var(--heritage-width-border-maxi)) var(--beacon-system-color-border-focus-outer, var(--beacon-color-shadow-focus));outline:var(--beacon-system-width-border-normal, var(--heritage-width-border-normal)) solid var(--beacon-system-color-border-focus-inner, var(--beacon-color-border-focus));outline-offset:0;position:relative;z-index:1}:host(:not([focus-override])) a:not([focus-override]):focus-visible{--heritage-width-border-normal: calc(var(--beacon-unit-base) / 8);--heritage-width-border-jumbo: calc(var(--beacon-unit-base) / 4);--heritage-width-border-maxi: calc(var(--beacon-unit-base) / 2);--total-ring-width: calc(var(--beacon-system-width-border-jumbo, var(--heritage-width-border-jumbo)) + var(--beacon-system-width-border-maxi, var(--heritage-width-border-maxi)) + var(--beacon-system-width-border-normal, var(--heritage-width-border-normal)));background-color:var(--beacon-system-color-background-link-focus, var(--beacon-color-background-link-focus))!important;border-block-end-color:unset;box-shadow:0 var(--beacon-system-width-border-jumbo, var(--heritage-width-border-jumbo)) 0 0 var(--beacon-system-color-border-link-focus, var(--beacon-color-border-link-focus));color:var(--beacon-system-color-text-set-navy, var(--beacon-color-text-set-navy))!important;outline:none;text-decoration:none}@media (forced-colors: active){:host(:not([focus-override])) a:not([focus-override]):focus-visible{border-block-end:var(--beacon-system-width-border-jumbo, var(--heritage-width-border-jumbo)) solid var(--beacon-system-color-border-link-focus, var(--beacon-color-border-link-focus))}}`, ht = V`[beacon-tag-name]:where([reset-spacing]) *{margin:0;padding:0}`, dt = V`:host{border:initial;box-sizing:border-box;display:block;font-size:initial;font-style:initial;font-variant:initial;font-weight:initial;line-height:initial;white-space:initial;word-break:break-word;word-spacing:initial;text-align:initial;text-indent:initial;text-transform:initial}:host *,:host *:before,:host *:after{box-sizing:inherit}input,button,textarea,select{font:inherit;letter-spacing:inherit}button{color:inherit;cursor:pointer}ul,ol{list-style-position:initial;list-style-type:revert}table{caption-side:initial;empty-cells:initial;border-collapse:initial;border-spacing:initial}`, ut = V`.has-cell-padding{padding-block:var(--beacon-cell-space-padding);padding-inline:var(--beacon-cell-space-padding)}.has-component-padding{padding-block:var(--beacon-component-space-padding);padding-inline:var(--beacon-component-space-padding)}@media (width >= 1600px){:host{--beacon-space-default: calc(10 * var(--beacon-unit-base)) !important;--beacon-grid-layout-space-margin: 10rem !important;--beacon-grid-gutter-size-inline: 2rem !important}}:host{color:var(--beacon-system-color-text-standard, var(--beacon-color-text-default));font-family:var(--beacon-system-font-family-body, var(--beacon-font-family-default));font-weight:var(--beacon-system-font-weight-light, var(--beacon-font-weight-normal));-webkit-font-smoothing:antialiased}[lang=zh]{font-family:var(--beacon-system-font-family-body, var(--beacon-font-family-cjk))}a,::slotted(a){color:var(--beacon-system-color-text-link, var(--beacon-color-hyperlink-default))}a:not(:is(:hover,:focus)){text-decoration:none}:host(:not([motion-state=enabled])),:host(:not([motion-state=enabled])) :is(*,*:before,*:after),:host(:not([motion-state=enabled])) ::slotted(*:not([motion-state=enabled])){animation:none;animation-duration:.01ms!important;animation-iteration-count:1!important;scroll-behavior:auto!important;transition:none!important}@media (prefers-reduced-motion: reduce){:host([motion-state=enabled]),:host([motion-state=enabled]) :is(*,*:before,*:after),:host([motion-state]),:host([motion-state]) :is(*,*:before,*:after){animation:none;animation-duration:.01ms!important;animation-iteration-count:1!important;scroll-behavior:auto!important;transition:none!important}}`;
var G = /* @__PURE__ */ ((o) => (o.CLICKABLE = "data-metrics-clickable", o.TYPE = "data-metrics-type", o.TEXT = "data-metrics-link-text", o.LOCATION = "data-metrics-location", o))(G || {});
const w = class w {
};
w.setPropertyOnEvent = (t, e, r, i) => {
  try {
    Object.defineProperty(t, r, {
      value: i || e[`${r}`],
      writable: !1
    });
  } catch {
  }
}, w.getAnalyticsEvents = () => {
  const t = ["gesture", "click", "touch", "change"];
  return Object.keys(window).filter((e) => /^on/.test(e) && new RegExp(t.join("|")).test(e));
}, w.setHostEventHandlerForAnalytics = (t, e) => {
  var s;
  const r = w.getAnalyticsEvents(), i = "beaconVersion";
  for (const n of r) {
    const c = n.slice(2);
    (s = t.shadowRoot) == null || s.addEventListener(
      c,
      (a) => {
        var h;
        const l = new a.constructor(c, a);
        w.setPropertyOnEvent(l, null, i, e);
        for (const d in a)
          w.setPropertyOnEvent(l, a, d);
        (h = t.shadowRoot) != null && h.contains(a.target) && t.dispatchEvent(l);
      },
      !0
    );
  }
};
let te = w;
function wt(o, t) {
  !o || !t || o instanceof SVGElement && (o.setAttribute(G.CLICKABLE, "true"), o.setAttribute(G.TYPE, "BTN"), o.setAttribute(G.TEXT, t));
}
function U(o, t, e, r) {
  const i = new CustomEvent(t, {
    bubbles: !0,
    cancelable: !1,
    composed: !0,
    detail: {},
    ...e
  });
  return o.dispatchEvent(i), i;
}
const we = (o) => !!o.deferrable, pt = (o) => {
  var t, e;
  return (!!((t = o.deferList) != null && t.includes(P.VISIBLE)) || !!((e = o.getAttribute("defer-until")) != null && e.includes(P.VISIBLE))) && o.isDeferUntilParent;
}, Ae = (o) => !!navigator.vendor && navigator.vendor.indexOf(o) > -1;
function bt(o) {
  return `${o}`.toLowerCase().replace(new RegExp(/[-_]+/, "g"), " ").replace(new RegExp(/[^\w\s]/, "g"), "").replace(new RegExp(/\s+(.)(\w*)/, "g"), (t, e, r) => `${e.toUpperCase() + r}`).replace(new RegExp(/\w/), (t) => t.toUpperCase());
}
const ft = "3.6.1", mt = {
  rootMargin: "1500px",
  threshold: 0
}, y = {
  version: ft,
  hidden: "hidden",
  safari: "Apple",
  divTagName: "div",
  deprecatedPropertyKeys: ["alternateAttributes", "sync", "alternateSlot"],
  defaultDeferOptions: mt
}, ee = (o) => {
  for (const t of o)
    if (t !== void 0) return t;
};
var gt = Object.defineProperty, g = (o, t, e, r) => {
  for (var i = void 0, s = o.length - 1, n; s >= 0; s--)
    (n = o[s]) && (i = n(t, e, i) || i);
  return i && gt(t, e, i), i;
}, O;
const v = class v extends N {
  constructor() {
    super(...arguments);
    he(this, O);
    X(this, O, !1), this.isDeferUntilParent = !1, this.deferrable = !0, this.focusOverride = !1, this.resetSpacing = !1, this.beaconTagName = "", this.version = y.version, this.motionState = "disabled", this.prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches, this.alternateSlots = /* @__PURE__ */ new Map(), this.onslotchange = (e) => {
      var s;
      const i = (s = e.target.name) != null ? s : "";
      this.slotDeprecationWarn(i);
    }, this.resolvedDeferOptions = {
      root: document,
      rootMargin: y.defaultDeferOptions.rootMargin,
      threshold: y.defaultDeferOptions.threshold
    }, this.deferUntilVisible = () => new Promise((e) => {
      if (!("IntersectionObserver" in window))
        e();
      else {
        const r = new IntersectionObserver((i) => {
          const [s] = i;
          s.isIntersecting && (r.disconnect(), e());
        }, this.getResolvedDeferOptions() || null);
        r.observe(this);
      }
    }), this.deferUntilIdle = () => {
      const e = new Promise((r) => {
        document.readyState !== "complete" ? window.addEventListener("load", () => r(), { once: !0 }) : r();
      });
      return "requestIdleCallback" in window ? Promise.all([
        new Promise((r) => {
          requestIdleCallback(() => {
            r();
          });
        }),
        e
      ]) : e;
    }, this.deferredChildEventHandler = (e) => new Promise((r) => {
      var i;
      e instanceof CustomEvent && ((i = e.detail) != null && i.type) ? (this.deferOptions && this.setDeferOptions(this.deferOptions), this.selectDeferUntilHandler(e.detail.type).then(() => r())) : r();
    }), this.renderStyles = (e, r) => {
      const i = [], s = new Set(this.constructor[e].flat(1 / 0));
      for (const n of s)
        i.push(n);
      i.reverse().forEach((n, c) => {
        var h;
        const a = document.createElement("style");
        a.setAttribute("slot", "lightDOM");
        let l = !1;
        if (a.textContent = n.toString(), r) {
          const d = Math.abs(c - i.length), b = `${r}-${d}`, p = this.getClosestHost();
          a.id = b, (p && ((h = p == null ? void 0 : p.shadowRoot) != null && h.querySelector(`#${b}`)) || !p && document.querySelector(`#${b}`)) && (l = !0);
        }
        l || this.prepend(a);
      });
    }, this.renderComponentModeStyles = (e = `${this.beaconTagName}-mode-styles`) => {
      var r;
      (r = this.componentModeStyles) == null || r.forEach((i, s) => {
        const n = document.createElement("style");
        n.textContent = i.toString();
        const c = `${e}-${s}`;
        n.id = c, !document.querySelector(`#${c}`) && document.head.append(n);
      });
    }, this.getScopedTag = (e) => {
      if (!e) return null;
      const r = this.getScopedTagPrefix() ? `${this.getScopedTagPrefix()}-${e}` : e;
      return st(r);
    };
  }
  /**
   * Extends Lit's definition of `observedAttributes`.
   *
   * Returns a list of attributes corresponding to the registered properties.
   * @nocollapse
   * @category attributes
   */
  static get observedAttributes() {
    const e = [];
    return this.hasDeprecatedProperties && this.alternateAttributesMap.forEach((r, i) => {
      this.elementProperties.has(r) && e.push(i);
    }), e.push(...super.observedAttributes), e;
  }
  /**
   * Extends Lit's default attributeChangedCallback to support deprecated properties.
   *
   * @param name Attribute name
   * @param _old Old value
   * @param value New value
   */
  attributeChangedCallback(e, r, i) {
    const { alternateAttributesMap: s, hasDeprecatedProperties: n, elementProperties: c } = this.constructor;
    if (n && s.size > 0) {
      const a = s.get(e), l = c.get(a), h = this.getPropertyOptions(e).alternateSlot;
      if (a)
        if (a !== W.NO_SYNC && (i === null ? this.removeAttribute((l == null ? void 0 : l.attribute) || a) : this.setAttribute((l == null ? void 0 : l.attribute) || a, i || "")), h) {
          const d = this.createPropertyDeprecationForSlotMessage(e, h);
          console.warn(d);
        } else
          console.warn(this.createPropertyDeprecationMessage(e, a, l == null ? void 0 : l.attribute));
    }
    super.attributeChangedCallback(e, r, i);
  }
  /**
   * Generates a console message to log when deprecated properties were used.
   *
   * @param name attribute that triggered the message
   * @param property property that the attribute aligns to
   * @param attribute correct attribute to use
   */
  createPropertyDeprecationMessage(e, r, i) {
    let s = `Beacon Warning: [${e}] will be deprecated as a prop of <${this.beaconTagName.toLowerCase()}> in a future release.`;
    return r !== W.NO_SYNC && (s += ` Start using [${i || r}] instead to avoid future disruptions.`), s;
  }
  /**
   * Generates a console message to log when a deprecated property is used
   * and should instead use the designated slot
   * @param property the name of the property being deprecated
   * @param slot the designated slot to use instead
   */
  createPropertyDeprecationForSlotMessage(e, r) {
    return `Beacon Warning: '${e}' will be deprecated as a prop of <${this.beaconTagName.toLowerCase()}> in a future release. Start using the slot: '${r}' instead to avoid future disruptions`;
  }
  /**
   * Extend's Lit's `createProperty` method for our own uses.
   * @param name Property Name
   * @param options Options for the property
   */
  static createProperty(e, r) {
    if (r) {
      const { alternateAttributes: i, attribute: s } = r, n = Object.prototype.hasOwnProperty.call(r, "sync");
      if (y.deprecatedPropertyKeys.forEach((c) => {
        Object.prototype.hasOwnProperty.call(r, c) && (this.hasDeprecatedProperties = !0);
      }), i && i.forEach((c) => {
        this.alternateAttributesMap.set(c, e);
      }), n && !r.sync) {
        const c = s != null ? s : e;
        this.alternateAttributesMap.set(c, W.NO_SYNC);
      }
    }
    super.createProperty(e, r);
  }
  /**
   * This is used to return the property options of a property when given only its attribute name,
   * e.g. the property pageTitle with an attribute name of 'page-title' will have no way of accessing its options
   * directly when attempting to grab the options with 'page-title' and elementProperties.get().
   * @param name the resolved attribute name of a `@property()` decorated property
   * @returns the options passed in `@property()` e.g. `{attribute: 'attribute-name', reflect: true}`
   */
  getPropertyOptions(e) {
    var i;
    const { elementProperties: r } = this.constructor;
    return (i = r.get(e)) != null ? i : [...r.values()].find((s) => s.attribute === e);
  }
  /**
   * Getter that returns private resolvedDeferOptions
   * @returns resolvedDeferOptions that are passed to an IntersectionObserver
   */
  getResolvedDeferOptions() {
    return this.resolvedDeferOptions;
  }
  /**
   * Converts space separated list prop of `defer-until` to a DeferUntil enum array
   */
  get deferList() {
    var e, r;
    return (r = (e = this.deferUntil) == null ? void 0 : e.split(" ").map((i) => i).filter((i) => !!i)) != null ? r : [];
  }
  /**
   * Logs a warning based on the slot name provided and details from the alternate slots map
   *
   * @param slotName name of the slot that has changed
   */
  slotDeprecationWarn(e) {
    const r = this.alternateSlots.get(e);
    if (r !== void 0) {
      let i;
      const s = `The '${e}' for for '${this.beaconTagName}'`;
      Object.keys(r).some((n) => n.match("alternate")) ? r.alternateAttribute ? i = `will be replaced by the element property '${r.alternateAttribute}'` : i = `will be replaced by the '${r.alternateSlots}' slot` : i = "will be removed", console.warn(`Beacon Deprecation Warning: ${s} ${i} in foundation@${r.version}`);
    }
  }
  /**
   * A setter that takes user input deferOptions and resolves them compared to existing deferOptions. Enables the setting
   * of isolated deferOptions and leaves unchanged options previously set intact.
   * @param options the defer-options object used in IntersectionObserver.
   */
  setDeferOptions(e) {
    if (!e) return;
    const r = { ...this.resolvedDeferOptions };
    this.resolvedDeferOptions = {
      root: ee([e == null ? void 0 : e.root, r == null ? void 0 : r.root, document]),
      rootMargin: ee([
        e == null ? void 0 : e.rootMargin,
        r == null ? void 0 : r.rootMargin,
        y.defaultDeferOptions.rootMargin
      ]),
      threshold: ee([
        e == null ? void 0 : e.threshold,
        r == null ? void 0 : r.threshold,
        y.defaultDeferOptions.threshold
      ])
    };
  }
  /**
   * Hides the visibility of the component. Used when component is deferred until specified condition.
   * @returns void
   */
  setDeferVisibilityStyles() {
    Ae(y.safari) || (this.style.visibility = y.hidden);
  }
  /**
   * Sets the component styles to visibile. Used when component meets condition specified to defer until.
   * @returns void
   */
  removeDeferVisibilityStyles() {
    Ae(y.safari) || this.style.removeProperty("visibility");
  }
  /**
   * Searches for a parent of component with defer-until attribute that is not solely defer-until="defined".
   * @returns closest lightDOM parent with [defer-until] attribute or null
   */
  getClosestDeferredParent() {
    const e = '[defer-until]:not([defer-until="defined"])', r = this.closest(e);
    if (r && we(r)) return r;
    const i = this.getClosestHost();
    if (i) {
      const s = i.closest(e);
      if (s && we(s)) return s;
    }
    return null;
  }
  /**
   * Runs in shadowDOM context. This method searches for the ShadowRoot then returns host of ShadowRoot.
   * @returns host element of this component of the shadowDOM
   */
  getClosestHost() {
    let e = this && this.parentNode;
    for (; e; ) {
      if (e instanceof ShadowRoot)
        return e.host;
      e = e.parentNode;
    }
    return null;
  }
  /**
   * Selects which deferUntil handler method to run on component.
   * @param deferUntilCriteria DeferUntil option that determines how component should defer.
   */
  selectDeferUntilHandler(e) {
    return new Promise((r) => {
      e.includes(P.VISIBLE) ? (this.setDeferVisibilityStyles(), this.deferUntilVisible().then(() => {
        this.removeDeferVisibilityStyles(), r();
      })) : e.includes(P.IDLE) ? (this.setDeferVisibilityStyles(), this.deferUntilIdle().then(() => {
        this.removeDeferVisibilityStyles(), r();
      })) : r();
    });
  }
  /**
   * Method that handles setup of deferUntil handler when deferUntil is configured locally via deferUntil prop on the component.
   */
  handleLocalDeferUntil() {
    return new Promise((e) => {
      this.deferOptions && this.setDeferOptions(this.deferOptions), this.selectDeferUntilHandler(this.deferList).then(() => e());
    });
  }
  /**
   * Method that looks for the closest element to the component with 'defer-until' attribute and either
   * applies the parent's deferUntil logic to the component immediately, if the parent is already registered as `isDeferUntilParent`,
   * or adds an eventListener to toggle parent's deferUntil logic on component once parent has emitted the beacon-event-deferred-child Event.
   * @param closestDeferredParent is the closest element to the component that has the 'defer-until' attribute set.
   */
  handleParentalDeferUntil(e) {
    return new Promise((r) => {
      if (e === null)
        r();
      else if (pt(e))
        this.selectDeferUntilHandler(e.deferList).then(() => r());
      else {
        const i = (s) => {
          this.deferredChildEventHandler(s).then(() => {
            e.removeEventListener($.DEFERRED_CHILD, i), r();
          });
        };
        e.addEventListener($.DEFERRED_CHILD, i);
      }
    });
  }
  /**
   * This method handles defer logic. If component has deferUntil prop set, it calls method to handle deferUntil logic locally.
   * Else if component has a closest element with 'defer-until' attribute set, it handles deferUntil based on closestDeferredParent's deferUntil settings.
   * If neither of the above criteria match, it completes connectedCallback.
   */
  handleDefer() {
    return new Promise((e) => {
      if (!this.deferrable || this.motionState === "enabled")
        e();
      else if (this.deferUntil)
        this.registerAsDeferUntilParent(), this.handleLocalDeferUntil().then(() => e());
      else {
        const r = this.getClosestDeferredParent();
        r ? this.handleParentalDeferUntil(r).then(() => e()) : e();
      }
    });
  }
  /**
   * Method that registers a component as parental component that can trigger deferUntil logic in child components. It should be placed in connectedCallback
   * of all components that need to trigger deferUntil logic in child components.
   */
  registerAsDeferUntilParent() {
    if (this.deferOptions && this.setDeferOptions(this.deferOptions), this.deferList.includes(P.VISIBLE)) {
      const e = new IntersectionObserver((r) => {
        for (const i of r)
          i.target && (this.isDeferUntilParent = !0, this.emitDeferredChild(), e.disconnect());
      }, this.getResolvedDeferOptions() || null);
      e.observe(this);
    }
  }
  /**
   * @returns the scope prefix from the beginning of the tagName.
   */
  getScopedTagPrefix() {
    const e = this.tagName.toLowerCase().split("-beacon")[0];
    return e.startsWith("beacon") ? "" : e;
  }
  /**
   * Defines this web component in the CustomElementRegistry.
   * @param tagNamePrefix lowercase string that prefixes default component tag names for scoping purposes
   */
  static registerComponent(e) {
    if (this.tagName) {
      const r = `${e ? `${e}-` : ""}${this.tagName}`;
      if (!customElements.get(r)) {
        const i = class extends this {
        };
        Object.defineProperty(i, "name", { value: bt(r) }), customElements.define(r, i), customElements.whenDefined(r).then(() => {
          const s = new CustomEvent($.REGISTER, { detail: r });
          document.dispatchEvent(s);
        }).catch((s) => {
          console.error(`Error defining Beacon Component ${r} in CustomElementsRegistry: `, s);
        });
      }
    }
  }
  /**
   * This will return beacon tag name to scoped tag Name
   * @param tag beaconTagName
   * @returns Scoped tagName
   */
  getScopedTagName(e) {
    return e ? this.getScopedTagPrefix() ? `${this.getScopedTagPrefix()}-${e}` : e : "";
  }
  /**
   * @param event
   * @event {BeaconEvents} beacon-event-click - emits when clicked
   */
  emitClick(e) {
    U(this, $.CLICK, !!this.onBeaconClick && this.onBeaconClick(e));
  }
  /**
   * @param event
   * @event {BeaconEvents} beacon-event-keydown - emits when a keydown event would be fired
   */
  emitKeydown(e, r) {
    U(this, $.KEYDOWN, !!this.onBeaconKeydown && this.onBeaconKeydown(r));
  }
  emitToggle(e) {
    U(this, $.TOGGLE, !!this.onBeaconToggle && this.onBeaconToggle(e));
  }
  /**
   * Emitter of beacon-event-deferred-child event used by components registered as deferUntilParents.
   * @param event
   * @event {BeaconEvents} beacon-event-deferred-child - signals to children of a deferUntil parent that they should behave as deferUntil components
   */
  emitDeferredChild(e) {
    U(this, $.DEFERRED_CHILD, {
      detail: {
        element: this,
        type: this.deferList
      }
    });
  }
  /**
   * Emits a beacon-event-keydown event as a default to mousedown handling
   * @param event
   */
  handleKeydown(e) {
    this.emitKeydown(e);
  }
  /**
   * Check if the component has a specific mixin applied.
   * @param name Name of the mixin to look for.
   * @returns True if the class contains that mixin.
   */
  hasMixin(e) {
    var r;
    try {
      if (!((r = this.constructor.mixins) == null ? void 0 : r.includes(e))) throw new Error(`This class does not implement ${e}.`);
      return !0;
    } catch (i) {
      return console.error(i), !1;
    }
  }
  /**
   * Check for a field with a specific value on the class.
   *
   * Useful when a mixin relies on the existance of another mixin.
   *
   * @param field Class property to check for on the mixin.
   * @param value Value of the given class field to check for.
   * @returns True if the value of the field is the same.
   */
  hasFieldAndValue(e, r) {
    try {
      if (!(e in this)) throw new Error(`${e} does not exist on this: ${this}`);
      return this[e] === r;
    } catch (i) {
      return console.error(i), !1;
    }
  }
  /**
   * Placeholder method that collects all method functionality that is decorated with @prerender
   * and is called in connectedCallback. This method should not be overridden directly.
   * The goal is to prevent direct overrides of connectedCallback in subclasses
   */
  prerender() {
  }
  /**
   * Placeholder method that collects all method functionality that is decorated with @postrender
   * and is called in firstUpdated. This method should not be overridden directly.
   * The goal is to prevent direct overrides of firstUpdated in subclasses
   */
  postrender() {
  }
  /**
   * Placeholder method that collects all method functionality that is decorated with @destroy
   * and is called in disconnectedCallback. This method should not be overridden directly.
   * The goal is to prevent direct overrides of disconnectedCallback in subclasses
   */
  destroy() {
  }
  /**
   * Enables or disables motion on this component.
   *
   * Looks for the closest element with `[motion-state]` to find its value and set the motion state of the component equal to that.
   *
   * @link https://developer.mozilla.org/en-US/docs/Web/API/Element/closest Element.closest() will return the element itself if it matches the selector.
   */
  setMotionState() {
    if (this.motionState === "enabled")
      return;
    const e = this.closest("[motion-state]"), r = e == null ? void 0 : e.getAttribute("motion-state");
    r && (r === "enabled" || r === "disabled") && (this.motionState = r);
  }
  /**
   * Removes the "defined" string value from defer-until attribute while leaving in place any other subString in the attribute.
   * This is a clean-up function called in connectedCallback that enables usage of applitools UltraFastGrid with defer-until="defined"
   * components.
   */
  removeDeferUntilDefined() {
    const e = this.getAttribute("defer-until");
    if (e) {
      if (e === "defined")
        this.removeAttribute("defer-until");
      else if (e.includes("defined")) {
        const r = e.split(" ").filter((i) => i !== "defined").join(" ");
        this.setAttribute("defer-until", r);
      }
    }
  }
  connectedCallback() {
    this.setMotionState(), this.removeDeferUntilDefined(), this.handleDefer().then(() => {
      super.connectedCallback(), le(this, O) || (te.setHostEventHandlerForAnalytics(this, this.version), X(this, O, !0)), this.renderStyles("lightDOMStyles", `${this.beaconTagName}-light-DOM-styles`), this.renderStyles("globalLightDOMStyles", "beacon-global-light-DOM-styles"), this.prerender();
    });
  }
  firstUpdated() {
    this.postrender(), U(this, $.ELEMENT_READY);
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.destroy();
  }
};
O = new WeakMap(), v.styles = [dt, ut, lt], v.tagName = "", v.shadowRootOptions = { ...N.shadowRootOptions, delegatesFocus: !0 }, v.alternateAttributesMap = /* @__PURE__ */ new Map(), v.hasDeprecatedProperties = !1, v.mixins = [], v.lightDOMStyles = [], v.globalLightDOMStyles = [ht, ct];
let f = v;
g([
  m({ attribute: "focus-override", type: Boolean, reflect: !0 })
], f.prototype, "focusOverride");
g([
  m({ attribute: "reset-spacing", type: Boolean, reflect: !0 })
], f.prototype, "resetSpacing");
g([
  m({ attribute: "beacon-tag-name", type: String, reflect: !0 })
], f.prototype, "beaconTagName");
g([
  m({ attribute: "beacon-version", reflect: !0 })
], f.prototype, "version");
g([
  m({ attribute: "defer-until" })
], f.prototype, "deferUntil");
g([
  m({ attribute: "defer-options" })
], f.prototype, "deferOptions");
g([
  m({ type: Function })
], f.prototype, "onBeaconClick");
g([
  m({ type: Function })
], f.prototype, "onBeaconKeydown");
g([
  m({ type: Function })
], f.prototype, "onBeaconToggle");
g([
  m({ attribute: "motion-state", reflect: !0 })
], f.prototype, "motionState");
g([
  it()
], f.prototype, "prefersReducedMotion");
export {
  G as A,
  f as B,
  at as E,
  u as T,
  m as a,
  $ as b,
  wt as c,
  st as d,
  U as e,
  V as i,
  et as j,
  _t as n,
  it as r,
  x as w,
  Be as x,
  $t as z
};
